import { render, staticRenderFns } from "./SpaceItem.vue?vue&type=template&id=c633ae6e"
import script from "./SpaceItem.vue?vue&type=script&lang=js"
export * from "./SpaceItem.vue?vue&type=script&lang=js"
import style0 from "./SpaceItem.vue?vue&type=style&index=0&id=c633ae6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports